import { render, staticRenderFns } from "./DrLauraLanding.vue?vue&type=template&id=0bd98004&"
import script from "./DrLauraLanding.vue?vue&type=script&lang=js&"
export * from "./DrLauraLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports